export const FbPixelAnalyticsEvents = {
  // Standard events
  CompleteRegistration: "CompleteRegistration",
  Purchase: "Purchase",
  StartTrial: "StartTrial",
  Contact: "Contact",
};
